import cdProfileCookie from '../../smartpak/smartpak.cdprofilecookie';
import {read} from '../../smartpak/cookie';

function getCustomerToken() {
    const cookie = read('EQCookie'),
        token = cookie ? cookie.split('=')[1] : '';
    return token;
}

export default function dataLayer(){
    window.dataLayer = window['dataLayer'] || []; 

    const token = getCustomerToken();

    if (token) {
        window.dataLayer.push({
            'customerWebToken': getCustomerToken(),
            'customerEmail': cdProfileCookie.CustomerEmail,
            'customerHashedEmail': cdProfileCookie.CustomerHashedEmail
        });
    }
}